import { render, staticRenderFns } from "./TableRelatedDocuments.vue?vue&type=template&id=0192619a&"
import script from "./TableRelatedDocuments.vue?vue&type=script&lang=js&"
export * from "./TableRelatedDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0192619a')) {
      api.createRecord('0192619a', component.options)
    } else {
      api.reload('0192619a', component.options)
    }
    module.hot.accept("./TableRelatedDocuments.vue?vue&type=template&id=0192619a&", function () {
      api.rerender('0192619a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/components/TableRelatedDocuments.vue"
export default component.exports